import { useSelector } from 'react-redux';
import { useIsFetching, useIsMutating } from '@taxdown/zeno-sama-query';
import { isLoadingSelector } from 'Store/modules/app/selectors';
import { LogoLoader } from 'Components/UI';
import { QueryKeys } from 'Types/common';

const Loader = (): JSX.Element | null => {
  const isLoading = useSelector(isLoadingSelector);

  const mutationsAndQueries = [
    useIsMutating({ mutationKey: [QueryKeys.RESTART_USER] }),
    useIsMutating({ mutationKey: [QueryKeys.RESET_USER] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_SAT_USER] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_USER_PHONE] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_PAY_LATER] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBMIT_ANUAL_DECLARATION] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBMITTED_USER_XML] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_INSTANT_REFUND] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBMIT_DECLARATION] }),
    useIsMutating({ mutationKey: [QueryKeys.DELETE_USER_KEY] }),
    useIsMutating({ mutationKey: [QueryKeys.PATCH_FILING_USERS] }),
    useIsMutating({ mutationKey: [QueryKeys.CONFIRM_DECLARATION] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBSCRIBE_FLEX_LITE] }),
    useIsMutating({ mutationKey: [QueryKeys.AUTO_RENEWAL] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBMIT_DECLARATION_CROSS_SELL] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBMIT_ANUAL_DECLARATION_CHECKOUT] }),
    useIsMutating({ mutationKey: [QueryKeys.SUBSCRIBE_FLEX_LITE_CHECKOUT] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_DASHBOARD_PHONE] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_CLABE_MUTATION] }),
    useIsMutating({ mutationKey: [QueryKeys.SAVE_PAY_LATER_XML] }),
    useIsMutating({ mutationKey: [QueryKeys.CHEKOUT_SESSION] }),
    useIsMutating({ mutationKey: [QueryKeys.CREATE_DOMICILIATION] }),
    useIsFetching({ queryKey: [QueryKeys.GET_CEP] }),
  ];

  const isOperationActive = mutationsAndQueries.some(operation => operation > 0);

  if (isOperationActive || isLoading > 0) {
    return <LogoLoader />;
  }
  return null;
};

export default Loader;
